import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import { i18n } from '@/plugins/i18n'
import Resource from 'vue-resource'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueAnalytics, {
  id: 'UA-111467685-1',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

Vue.use(Resource)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
